export default __webpack_public_path__ + "static/media/plus.1bd3a59e.svg";